export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const addMinutes = (date, minutes) => {
    return new Date(new Date(date).getTime() + minutes * MINUTE).toISOString();
};
export const calculateTimeLeft = (timestamp) => {
    const difference = +new Date(timestamp) - +new Date();
    return difference > 0 ? difference : 0;
};
export const formatTimeLeft = (timeLeft, showHours = true) => {
    const hours = String(Math.floor(timeLeft / HOUR));
    const minutes = String(Math.floor((timeLeft / MINUTE) % 60));
    const seconds = String(Math.floor((timeLeft / SECOND) % 60));
    return `${showHours ? `${hours.padStart(2, '0')}:` : ''}${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
};
//# sourceMappingURL=time.js.map